import TaskCard from "./taskCard";
import listingImg from "../../images/listingImg.jpg";
import SubHeader from "./subheader";
import { useEffect, useState } from "react";
import { getService, PostService } from "../../services/genericPostService";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Path } from "../../RoutesUtils";
import Header from "../header/header";

const TaskList = () => {
  const [tasks, setTasks] = useState([]);
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    } else {
      getTasks();
    }
  }, []);

  const getTasks = () => {
    const data = {
      user_id: userId,
    };
    const url = "/fmeApi/get_task.php";
    getService(url, data, setData);
  };

  const setData = (response) => {
    let data = [...response.tasks];
    data = data.map((val) => {
      return {
        ...val,
        task_start_time: moment(val.task_start_time, "HH:mm:ss.SSSSSS").format(
          "HH:mm"
        ),
        task_end_time: moment(val.task_end_time, "HH:mm:ss.SSSSSS").format(
          "HH:mm"
        ),
      };
    });
    setTasks(data);
  };
  console.log("Task", tasks);
  return (
    <>
      <Header />
      <SubHeader title="To-do liste" href="/todoList/addtask" />
      <div className="w-full container mx-auto mt-9 lg:px-8 px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {tasks.map((task, index) => (
            <TaskCard isPage key={index} {...task} getTasks={getTasks} />
          ))}
        </div>
      </div>
    </>
  );
};

export default TaskList;
